import { render, staticRenderFns } from "./SearchResultsPage.vue?vue&type=template&id=58401100&scoped=true&"
import script from "./SearchResultsPage.vue?vue&type=script&lang=js&"
export * from "./SearchResultsPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsPage.vue?vue&type=style&index=0&id=58401100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58401100",
  null
  
)

export default component.exports